import queryString from "query-string";

function getParsedQueryString() {
	return queryString.parse(window.location.search);
}

export { getParsedQueryString };


// WEBPACK FOOTER //
// ./src/utils/query.js